import { merge } from 'highed';
import { cloneDeep } from 'lodash';

export const getConfig = (state) => state.layoutEditorPage;
export const getTableSpecificConfig = (state) => state.tableEditorPage;
export const getAggregatedOptions = (projectConfig) =>
  merge(cloneDeep(projectConfig.themeOptions.options), cloneDeep(projectConfig.customizedOptions));
